import styled from 'styled-components';
const CARD_HEIGHT = 166;
export const StackContainer = styled.div `
  width: 100%;
  max-width: 400px;
  min-height: ${({ minHeight }) => minHeight ? `calc(${minHeight}px + 16px)` : '305px'};
  height: ${({ height }) => (height ? `calc(${height}px + 16px)` : '305px')};
  position: relative;
  transition: min-height 100ms ease-in-out;

  ${({ isMobile, minHeight, numberOfActivities }) => isMobile &&
    `
    min-height: ${minHeight ? `calc(${minHeight}px + ${numberOfActivities >= 3 ? 60 : numberOfActivities === 2 ? 32 : 16}px)` : '305px'}
  `}
`;
export const Container = styled.div `
  content: ${({ forceRerender }) => `"${forceRerender}"`};
  position: absolute;
  top: 0;
  left: 50%;
  width: 100%;
  transform: translate(-50%, -50%);
  border-radius: 8px;
  cursor: ${({ isActiveNode }) => (isActiveNode ? 'initial' : 'pointer')};
  z-index: 2;
  // fixes border radius on safari
  overflow: hidden;
  isolation: isolate;

  ${({ preventAnimation, bringForward, bringBack }) => !preventAnimation &&
    `animation: ${bringForward
        ? 'swapForwards 420ms forwards'
        : bringBack
            ? 'swapBackwards 420ms forwards'
            : 'wiggle 420ms forwards'}`};

  &:nth-last-child(n + 4) {
    --y: 0px;
    --scale: 0.85;
    --wiggleScale: 0.03;
    max-height: ${CARD_HEIGHT}px;
    overflow: hidden;
    transform: translate(-50%, var(--y)) scale(var(--scale));
  }

  &:nth-last-child(3) {
    --y: 0px;
    --scale: 0.9;
    --wiggleScale: 0.03;
    max-height: ${CARD_HEIGHT}px;
    overflow: hidden;
    box-shadow: none;
    transform: translate(-50%, var(--y)) scale(var(--scale));
  }

  &:nth-last-child(2) {
    --y: ${({ numberOfNodes }) => (numberOfNodes <= 2 ? '0px' : '18px')};
    --scale: 0.95;
    --wiggleScale: -0.03;
    max-height: ${CARD_HEIGHT}px;
    overflow: hidden;
    box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.05);
    transform: translate(-50%, var(--y)) scale(var(--scale));
  }

  &:nth-last-child(1) {
    --y: ${({ numberOfNodes }) => numberOfNodes <= 1 ? '0px' : numberOfNodes === 2 ? '18px' : '38px'};
    --scale: 1;
    --wiggleScale: 0.03;
    transform: translate(-50%, var(--y)) scale(var(--scale));
    box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.1);
  }

  @keyframes swapForwards {
    50% {
      transform: translate(
          -50%,
          calc(var(--y) - ${({ isMobile }) => (isMobile ? '100px' : '150px')})
        )
        scale(${({ isMobile }) => (isMobile ? 0.95 : 1)});
      animation-timing-function: ease-in;
    }
    100% {
      transform: translate(-50%, var(--y)) scale(1);
      z-index: 3;
    }
  }

  @keyframes swapBackwards {
    50% {
      transform: translate(
          -50%,
          calc(var(--y) - ${({ isMobile }) => (isMobile ? '110px' : '150px')})
        )
        scale(0.85);
      animation-timing-function: ease-in;
    }
    100% {
      transform: translate(-50%, calc(var(--y) - 15px)) scale(0.15);
      z-index: 1;
    }
  }

  @keyframes wiggle {
    75% {
      transform: translate(-50%, calc(var(--y)))
        scale(calc(var(--scale) + var(--wiggleScale)));
    }
    100% {
      transform: translate(-50%, calc(var(--y))) scale(calc(var(--scale)));
    }
  }
`;
export const Mask = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(
    255,
    255,
    255,
    ${({ opacity }) => (opacity ? opacity : 0.5)}
  );
  z-index: 6;
  border-radius: 8px;
  animation: maskFadeIn 420ms forwards;

  @keyframes maskFadeIn {
    0% {
      background: rgba(255, 255, 255, 0);
    }
    50% {
      background: rgba(
        255,
        255,
        255,
        ${({ opacity }) => (opacity ? opacity : 0.5)}
      );
    }
  }
`;
/**
 * Workaround to increase clickable area between steps and location
 */
export const ClickPadding = styled.div `
  content: '';
  position: absolute;
  top: -12px;
  width: 100%;
  height: 20px;
  cursor: pointer;
  user-select: none;
`;
